import { render, staticRenderFns } from "./dialogBox.vue?vue&type=template&id=8cfcfb1e&scoped=true&"
import script from "./dialogBox.vue?vue&type=script&lang=js&"
export * from "./dialogBox.vue?vue&type=script&lang=js&"
import style0 from "./dialogBox.vue?vue&type=style&index=0&id=8cfcfb1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfcfb1e",
  null
  
)

export default component.exports